module.exports = "<div class=\"{{ctrl.baseContainerClass}}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <h1>{{ctrl.pageTitle}}</h1>\n\n      <uib-accordion close-others=\"true\">\n        <div uib-accordion-group class=\"bs-callout bs-callout-info\" heading=\"{{faq.question}}\" ng-repeat=\"faq in ctrl.data\">\n          <div ng-bind-html=\"faq.answer\"></div>\n        </div>\n      </uib-accordion>\n\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/directories/faq/list/faq-directory.html
// module id = 252
// module chunks = 0